<template lang="html">
  <v-dialog v-model="intDialogVisible" max-width="80%" class="addValueModal addComment" scrollable attach="body">
    <v-card>
      <div class="toptophead">
        <div class="startupName">
          {{vote.startup.name}}
        </div>
        <div class="interestLevel">
          <span class="high" v-if="vote.averageVotePerStartup >= 4 ">{{$t("TOP RATED")}}</span>
          <span class="medium"  v-else-if="vote.averageVotePerStartup >= 3 ">{{$t("AVERAGE RATING")}}</span>

          <span class="low"  v-else>{{$t("BELOW AVERAGE RATING")}}</span>

        </div>
        <div class="close" @click="close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85219 2.15L7.80219 7.1L12.7522 2.15C12.9522 1.95 13.2622 1.95 13.4622 2.15C13.6622 2.35 13.6622 2.66 13.4622 2.86L8.51219 7.8L13.4622 12.75C13.6622 12.95 13.6622 13.26 13.4622 13.46C13.2622 13.66 12.9522 13.66 12.7522 13.46L7.80219 8.51L2.85219 13.46C2.65219 13.66 2.34219 13.66 2.14219 13.46C1.94219 13.26 1.94219 12.95 2.14219 12.75L7.10219 7.8L2.15219 2.85C1.95219 2.66 1.95219 2.34 2.15219 2.15C2.34219 1.95 2.66219 1.95 2.85219 2.15Z" fill="#0A2071"/>
          </svg>

        </div>
      </div>

      <div class="infoStartup">
        <StartupHeader :startup="vote.startup" :isRestrict="false"/>
        <div class="mt50">
          <StartupInfoTab :startup="vote.startup" :isRestrict="false"/>

        </div>
        <div class="viewModeToggle">
          <button type="button" @click="viewMode= 'scores'" :class='(viewMode == "scores") ? "active" : "notactive"' class="viewModeBtn" name="button">Scores</button>

          <button type="button" @click="viewMode= 'byjduge'" :class='(viewMode == "byjduge") ? "active" : "notactive"' class="viewModeBtn" name="button">Judges</button>
        </div>
        <div class="view" v-if="viewMode == 'byjduge'">


        <div class="searchForJudges">
          <div class="counterResults">
            <span class="resutlsLabel"> {{ $t("Results :") }}</span>
            <span class="resultValue"> {{filterList.length}} <span v-if="filterList.length > 1">{{$t("Judges")}}</span><span v-else>{{$t("Judge")}}</span></span>
          </div>
          <div class="">

          </div>

          <div class="searchForAnExpert">
            <div class="quicksearch">
              <input type="text" class="input_filtre " name="" :placeholder="$t('Search for an expert')" v-model="filtre">

            </div>

          </div>

        </div>
        <div class="row listOfJudgesVotes">
          <div class="oneJudgeVote" v-for="(voting, c) in filterList" :key="c">

            <div class="head wrapwrap">
              <span class="userProfile">{{generateInitials(voting.name)}}</span>
              <span class="judgeName">
                <span class="spanJudgeName">{{voting.name.replace(/\b\w/g, char => char.toUpperCase())}}</span>
                <span v-if="voting.position"><br/>{{voting.position}}</span>

                <img :src="require('@/assets/feedback.svg')" v-if="assessment.disableFeedback == false || voting.comments" alt="" @click="showFeedBackBy(voting)">
              </span>


              <FeedbackDetail :vote="voting" v-if='shownFeedback.includes(voting._id.$oid)' />

            </div>

            <div class="interestLevel mt20">
              <span class="high" v-if="voting.collab_interest_level == 'high' ">{{$t("HIGH INTEREST")}}</span>
              <span class="medium"  v-else-if="voting.collab_interest_level == 'medium' ">{{$t("MEDIUM INTEREST")}}</span>

              <span class="low"  v-else>{{$t("LOW INTEREST")}}</span>

            </div>
            <div class="voteDetail mt20">

                <div class="detailsContent">
                  <!-- <div class="oneDetail" v-for="(criteriaGroup, c ) in averageVotesByGroup(voting.criteriaVotes)" :key="c">

                    <div class="value">
                        <span class="voteValue">{{ formattedNumber(criteriaGroup.averageVote)}}&nbsp;/&nbsp;5</span>
                        <button class="voteBtton" type="button" v-if="detailsToogled != criteriaGroup.groupId || detailsVote != voting._id.$oid " @click="toogleDetails(criteriaGroup.groupId,voting._id.$oid)" name="button">
                          <span class="voteCriteria">{{ getGroupNameById(criteriaGroup.groupId)}}</span>

                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.99709 11.2004C7.53042 11.2004 7.06375 11.0204 6.71042 10.6671L2.36375 6.32042C2.17042 6.12708 2.17042 5.80708 2.36375 5.61375C2.55708 5.42042 2.87708 5.42042 3.07042 5.61375L7.41708 9.96042C7.73708 10.2804 8.25708 10.2804 8.57709 9.96042L12.9238 5.61375C13.1171 5.42042 13.4371 5.42042 13.6304 5.61375C13.8238 5.80708 13.8238 6.12708 13.6304 6.32042L9.28375 10.6671C8.93042 11.0204 8.46375 11.2004 7.99709 11.2004Z" fill="#3982C4"/>
                          </svg>
                        </button>
                        <button type="button" class="voteBtton reverseTheSvg" v-if="detailsToogled == criteriaGroup.groupId && detailsVote== voting._id.$oid" @click="detailsToogled = null;detailsVote=null;" name="button">
                          <span class="voteCriteria">{{ getGroupNameById(criteriaGroup.groupId)}}</span>

                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.99709 11.2004C7.53042 11.2004 7.06375 11.0204 6.71042 10.6671L2.36375 6.32042C2.17042 6.12708 2.17042 5.80708 2.36375 5.61375C2.55708 5.42042 2.87708 5.42042 3.07042 5.61375L7.41708 9.96042C7.73708 10.2804 8.25708 10.2804 8.57709 9.96042L12.9238 5.61375C13.1171 5.42042 13.4371 5.42042 13.6304 5.61375C13.8238 5.80708 13.8238 6.12708 13.6304 6.32042L9.28375 10.6671C8.93042 11.0204 8.46375 11.2004 7.99709 11.2004Z" fill="#3982C4"/>
                          </svg>
                        </button>
                    </div>
                    <div class="progress-bar">
                      <div class="progress-bar-fill" :style="{ width: computedProgress(criteriaGroup.averageVote) + '%' }"></div>
                    </div>
                    <div class="innerDetailsContent">


                    <div class="detail43234 small" v-if="detailsToogled ==criteriaGroup.groupId && detailsVote == voting._id.$oid">
                      <div class="oneDetail small" v-for="(criteria, c ) in criteriaByGroup(criteriaGroup.groupId,voting.criteriaVotes)" :key="c">
                        <div class="value detailsCriteria">
                          <span class="voteCriteria">{{ criteria.details.name}}
                          </span>

                            <span class="voteValue">{{formattedNumber(criteria.vote)}}&nbsp;/&nbsp;5</span>

                        </div>
                        <div class="progress-bar">
                          <div class="progress-bar-fill-2" :style="{ width: computedProgress(criteria.vote) + '%' }"></div>
                        </div>
                      </div>
                    </div>
                            </div>
                  </div> -->
                  <div
                    class="oneDetail"
                    v-for="(criteriaGroup, c) in averageVotesByGroup(voting.criteriaVotes)"
                    :key="c"
                  >
                    <div class="value">
                      <span class="voteValue">
                        {{ formattedNumber(criteriaGroup.averageVote) }}&nbsp;/&nbsp;5
                      </span>
                      <button
                        class="voteBtton"
                        type="button"
                        @click="toggleDetails(criteriaGroup.groupId, voting._id.$oid)"
                        :class="{ reverseTheSvg: isDetailsToggled(criteriaGroup.groupId, voting._id.$oid) }"
                        name="button"
                      >
                        <span class="voteCriteria">
                          {{ getGroupNameById(criteriaGroup.groupId) }}
                        </span>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.99709 11.2004C7.53042 11.2004 7.06375 11.0204 6.71042 10.6671L2.36375 6.32042C2.17042 6.12708 2.17042 5.80708 2.36375 5.61375C2.55708 5.42042 2.87708 5.42042 3.07042 5.61375L7.41708 9.96042C7.73708 10.2804 8.25708 10.2804 8.57709 9.96042L12.9238 5.61375C13.1171 5.42042 13.4371 5.42042 13.6304 5.61375C13.8238 5.80708 13.8238 6.12708 13.6304 6.32042L9.28375 10.6671C8.93042 11.0204 8.46375 11.2004 7.99709 11.2004Z"
                            fill="#3982C4"
                          />
                        </svg>
                      </button>
                    </div>
                    <div class="progress-bar">
                      <div
                        class="progress-bar-fill"
                        :style="{ width: computedProgress(criteriaGroup.averageVote) + '%' }"
                      ></div>
                    </div>
                    <div
                      class="innerDetailsContent"
                      v-if="isDetailsToggled(criteriaGroup.groupId, voting._id.$oid)"
                    >
                      <div
                        class="oneDetail small"
                        v-for="(criteria, c) in criteriaByGroup(criteriaGroup.groupId, voting.criteriaVotes)"
                        :key="c"
                      >
                        <div class="value detailsCriteria">
                          <span class="voteCriteria">
                            {{ criteria.details.name }}
                          </span>
                          <span class="voteValue">
                            {{ formattedNumber(criteria.vote) }}&nbsp;/&nbsp;5
                          </span>
                        </div>
                        <div class="progress-bar">
                          <div
                            class="progress-bar-fill-2"
                            :style="{ width: computedProgress(criteria.vote) + '%' }"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

            </div>
          </div>
        </div>
              </div>
  <div class="view scoreView" v-if="viewMode == 'scores'">
    <div class="row text-center">
        <span class="scoreTitle">{{$t("Judge's scores")}}</span>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6 col-xl-4 oneScore">
        <span class="subScoreTitle">{{$t('Average score')}}</span>
        <div class="inner">
          <AverageVote :vote="vote"/>

        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-4 oneScore">
        <span class="subScoreTitle">{{$t('Scores per criteria')}}</span>
        <div class="inner">
          <VoteResultsDetailsInner  :criteriaGroups="criteriaGroups" :vote="vote"/>


        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-4 oneScore">
        <span class="subScoreTitle">{{$t("Judges' recommendation")}}</span>
        <div class="inner">
          <InterestRepartitionDetails  :vote="vote"/>

        </div>
      </div>

    </div>
  </div>
      </div>
  </v-card>
  </v-dialog>

</template>


<script>
import StartupInfoTab from '@/components/StartupInfoTab.vue'
import StartupHeader from '@/components/StartupHeader.vue'
import FeedbackDetail from '@/components/FeedbackDetail.vue'
import InterestRepartitionDetails from '@/components/InterestRepartitionDetailsInside.vue'
import VoteResultsDetailsInner from '@/components/VoteResultsDetailsInner.vue'
import AverageVote from '@/components/AverageVote.vue'



export default {
  name : "VoteNextStep",
  data(){
    return {
      shownFeedback:[],
      detailsToogled:null,
      detailsVote: null,
      filtre: "",
       toggledDetails: {},
      viewMode: 'scores'
    }
  },
  components:{
    StartupInfoTab,
    StartupHeader,
    FeedbackDetail,
    InterestRepartitionDetails,
    VoteResultsDetailsInner,
    AverageVote
  },
  methods:{
    toggleDetails(groupId, voteId) {
       // Ensure an entry for this voteId exists
       if (!this.toggledDetails[voteId]) {
         this.toggledDetails[voteId] = []; // Initialize array for voteId
       }

       const toggledGroups = this.toggledDetails[voteId];

       // Toggle the groupId for the specified voteId
       if (toggledGroups.includes(groupId)) {
         this.toggledDetails[voteId] = toggledGroups.filter(
           (id) => id !== groupId
         );
       } else {
         this.toggledDetails[voteId].push(groupId);
       }
     },
     isDetailsToggled(groupId, voteId) {
       // Check if the groupId is toggled for the given voteId
       return this.toggledDetails[voteId]?.includes(groupId) || false;
     },
    close(){
        this.$emit('close',false)
    },
    hideDetails(){
      this.shownFeedback = null;
    },
    // showFeedBackBy(vote){
    //   this.shownFeedback[] = vote._id.$oid;
    // },
    showFeedBackBy(vote) {
    const id = vote._id.$oid;
    const index = this.shownFeedback.indexOf(id);

    if (index === -1) {
      // If not in the array, add it
      this.shownFeedback.push(id);
    } else {
      // If already in the array, remove it
      this.shownFeedback.splice(index, 1);
    }
  },
    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }).format(number);
    },
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },
       getGroupNameById(id) {
         console.log("search id:",id);
         console.log(this.criteriaGroups);
         var group = this.criteriaGroups.find(g => g._id.$oid == id);
         console.log("dinf ",group);
         return group ? group.name : null; // Return the groupname or null if not found
       },
       averageVotesByGroup(voting){
         const groupVotes = {};

        voting.forEach(item => {
          
            const groups = Array.isArray(item.details.group) ? item.details.group : [item.details.group];
            groups.forEach(group => {
              const groupId = group.$oid;

              // Initialize the group if it doesn't exist
              if (!groupVotes[groupId]) {
                groupVotes[groupId] = {
                  totalVotes: 0,
                  count: 0
                };
              }

              // Accumulate the votes for each group
              groupVotes[groupId].totalVotes += item.vote;
              groupVotes[groupId].count += 1;
            });
          });

          // Step 2: Calculate the average for each group
          const averageVotesByGroup = Object.keys(groupVotes).map(groupId => {
            return {
              groupId,
              averageVote: groupVotes[groupId].totalVotes / groupVotes[groupId].count
            };
          });
          return averageVotesByGroup;

       },
       criteriaByGroup(gid,voting) {
         var filteredCriteria = voting.filter(item => {
         // Check if 'group' is an array or a single object ID
         var groups = Array.isArray(item.details.group) ? item.details.group : [item.details.group];

         // Check if any of the groups match the groupId
         return groups.some(group => group.$oid === gid);
       });
       return filteredCriteria.filter(item => item.vote != null);
     },
     toogleDetails(gid,vid){
       this.detailsToogled = gid;
       this.detailsVote =  vid;
     },
     generateInitials(name) {
       const nameParts = name.trim().split(' ');

      // Check if there are at least two parts (first and last name)
      if (nameParts.length < 2) {
        // If there's only one name, return the first letter only
        return nameParts[0].charAt(0).toUpperCase();
      }

      // Get the first letter of the first word and the last word
      const firstInitial = nameParts[0].charAt(0).toUpperCase();  // First word initial
      const lastInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase(); // Last word initial

      // Return combined initials
      return `${firstInitial}${lastInitial}`;
    }
  },
  watch: {
    dialogVisible: function(){
      console.log("toto",this.vote);
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    },

  filterList() {
    var searchTerm = this.filtre.toLowerCase();

      const filteredCriteriaList = this.judgesVote.filter(item =>
        item.name.toLowerCase().includes(searchTerm)
      );

      const order = {
        high: 1,
        medium: 2,
        low: 3
      };

      console.log("filteredCriteriaList",filteredCriteriaList);

    return filteredCriteriaList.sort((a, b) => {
        return order[a.collab_interest_level] - order[b.collab_interest_level];
    });
  },
  },
  props: {
    dialogVisible: Boolean,
    vote: Object,
    assessment: Object,
    judgesVote : Array,
    criteriaGroups: Object,
  },
}
</script>

<style media="screen" scoped>

.details{
  position: absolute;
  background: #FFF;

  color: #000;
  bottom: 0;
  left: 0;
  z-index:99;
  transform: translateY(calc(100% + 10px));
  width:90%;
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);

}

.infoStartup{
  margin-left:50px;
  margin-right: 50px;
  margin-top:100px;
}

.mt50{
  margin-top:50px;
}
.oneJudgeVote{
  padding-top:20px;
  padding-bottom: 20px;

}


.voteDetail .detailsContent{

  display: flex;
  flex-direction: column;
  gap:20px;
  font-size:14px;
  line-height: 20px;
}

.voteDetail .value{
  display:flex;
  align-items: center;
  gap:10px;
}
.voteDetail .voteValue{
  font-weight: 100;
  font-size:32px;
  color:#0A2071;
  line-height: 35px;
}
.voteDetail .voteCriteria{
  color:#0A2071;
  font-size:16px;
  font-weight: 100;
  text-align:left;
}

.voteDetail .progress-bar {
  margin-top:10px;
  width: 100%;
  height: 8px; /* Adjust the height to match your example */
  background-color: #d3eaff; /* Light blue background color */
  border-radius: 4px; /* Rounded corners */
  overflow: hidden;
}

.voteDetail .progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}
@media screen and (max-width:990px){
.oneScore{
  margin-top:50px;
}
}

.voteDetail .oneDetail.small .value{
  display:flex;
  justify-content:  space-between;
  gap:10px;

}
.voteDetail .oneDetail.small .voteValue{
  font-weight: 100;
  font-size:20px;
  color:#0A2071;
  line-height: 25px;
}
.oneDetail.small .voteCriteria{
  color:#0A2071;
  font-size:14px;
  font-weight: 400;
}

.voteDetail .oneDetail.small .progress-bar {
  margin-top: 5px;
  width: 100%;
  height: 4px;
  background-color: #d3eaff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.voteDetail .progress-bar-fill {
  height: 100%;
  background-color: #4a90e2; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}
.voteDetail .progress-bar-fill-2 {
  height: 100%;
  background-color: #125AA4; /* Dark blue color */
  transition: width 0.3s ease; /* Smooth transition for progress */
  border-radius: 4px; /* To match the rounded corners */
}

.voteDetail .detail.small{
  margin-top:10px;
  display: flex;
  flex-direction: column;
  gap:10px;
}

.voteDetail .reverseTheSvg svg{
  transform:rotate(-180deg);
}

.voteDetail .voteCriteria small{
  font-weight: 200;
  font-size:12px;
}



.interestLevel .low{
  background:#FFE2E5;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#FA5A7D;
  border-radius:20px;
}
.interestLevel .medium{
  background:#FFF4DE;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#FFAA2A;
  border-radius:20px;
}
.interestLevel .high{
  background:#E7FFEF;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#3AC851;
  border-radius:20px;
}

.head{
  display:flex;
  gap:10px;
  border-bottom:1px solid #125AA433;
  padding-bottom: 20px;
  align-items: center;
}
.judgeName{
  font-size:16px;
  color:#0A2071;
  font-weight: 300;
  line-height:20px;
}
.spanJudgeName{
  font-size:18px;
  color:#0A2071;
  font-weight: 500;
    line-height:20px;
}

.userProfile{

  width: 30px;               /* Set a width */
height: 30px;              /* Set a height */
border-radius: 50%;         /* Make it circular */
background-color: #125AA4;  /* Background color */
color: white;               /* Text color */
display: flex;              /* Use flexbox for centering */
justify-content: center;    /* Center horizontally */
align-items: center;        /* Center vertically */
text-align: center;         /* Center text */
font-size: 16px;            /* Font size */
line-height: 1.2;

}


.oneJudgeVote .head{
  position:relative;
}

.listOfJudgesVotes{
  margin-bottom: 50px;
  display:flex;
  gap:50px;
}

.oneJudgeVote{
  width:calc(25% - 50px);
}

@media screen and (max-width:1500px){
  .oneJudgeVote{
    width:calc(33% - 50px);
  }
}

@media screen and (max-width:1250px){
  .oneJudgeVote{
    width:calc(50% - 50px);
  }
}


@media screen and (max-width:990px){
  .oneJudgeVote{
    width:100%;
  }
}

.searchForJudges .input_filtre{
  border:1px solid #3783C5;
  padding:10px;
  width:300px;
  border-radius:200px;
  color:#3783C5;
}

.searchForAnExpert{
  position:relative;
}
.searchForAnExpert::after{
  position:absolute;
  top: 8px;
  right:15px;
  content:  url('@/assets/loupe.svg');
}
.searchForJudges{
  display:flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.resutlsLabel{
  font-size:14px;
  font-weight: 700;
}
.resultValue{
  font-size:14px;
  font-weight: 400;
  color:#73A7D6;
}

.counterResults{
  display:flex;
  gap:5px;
}


.toptophead{
  position:fixed;
  right:0px;
  top:0px;
  left:0;
  padding:20px;
  z-index: 99999;
  background:#FFF;
  display:flex;
  align-items: center;
  justify-content: space-between;
box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.toptophead > div{
  flex: 1;
}
.toptophead .interestLevel{text-align: center;}
.toptophead .startupName{
  font-size:25px;
  font-weight: 600;
  text-align:left;
}
.close{
  text-align:right;
    cursor:pointer;
}

.viewModeToggle{
  display:flex;
  justify-content: center;
  gap:0;
}
.viewModeToggle .viewModeBtn{
  padding:10px 30px;
  color:#FFF;
  background:#125AA4;
  font-size:16px;
  font-weight: 400;
}
.viewModeToggle .viewModeBtn.active{
  background:#3883C5;
}

.inner{
  margin-top:25px;
}

.subScoreTitle{
  color:#04246A;
  font-size:20px;
  font-weight:600;
}
.view{
  margin-top:25px;
  margin-bottom: 100px;
}
.scoreView{
  display:flex;
  flex-direction: column;
}

.scoreTitle{
  margin-bottom: 25px;
  color:#04246A;
  font-size:25px;
  font-weight:600;
}
.oneScore{
  padding-left:50px;
  padding-right: 50px;
}

.voteBtton{
  display:flex;
  gap:5px;
  align-items:center;
    cursor:pointer;
}

.wrapwrap{
  flex-wrap: wrap;
}
.innerDetailsContent{
  margin-top:10px;
}



@media screen and (max-width:990px){
  .quicksearch{
    max-width: 100%;
    width:100%;
    margin-top:20px;
    margin-bottom:20px;
  }
  .quicksearch .input{
    max-width: 100%;
    width:100%;
      /* border: 1px solid #fff;
      background: transparent;
      padding: 5px 20px;
      border-radius: 200px;
      outline: none;
      color: #fff;
      font-weight: bold;
      letter-spacing: 1px; */
  }
}
</style>
